import CoreBase from '../../../services/engines/CoreBase';

const DEFAULT_STRATEGIES = ['dialog', 'css', 'body', 'saver', 'schema', 'titleBarActions', 'selectSources'];

/**
 * FormBuilderFormState — converts between selected config and form state, and builds normalized config.
 */
class FormBuilderFormState extends CoreBase {
    _name = 'FormBuilderFormState';

    /**
     * Creates a form state from a selected config.
     *
     * @param {object|null} selected
     * @returns {object}
     */
    fromSelected = (selected) => ({
        rk: selected?.rk ?? '',
        name: selected?.name ?? '',
        baseClass: selected?.baseClass ?? 'JxFormResizableBase',
        outputPath: selected?.outputPath ?? '',
        osSlash: selected?.osSlash ?? 'win',
        title: selected?.title ?? '',
        description: selected?.description ?? '',
        top: selected?.top ? String(selected.top) : '120',
        left: selected?.left ? String(selected.left) : '',
        width: selected?.width ? String(selected.width) : '600',
        height: selected?.height ? String(selected.height) : '400',
        fields: selected?.fields ?? [],
        strategies: selected?.strategies ?? DEFAULT_STRATEGIES,
    });

    /**
     * Returns a default form state with empty rk and a standard set of fields.
     * Used as the starting point for a new form config.
     * @returns {object}
     */
    createDefault = () =>
        this.fromSelected({
            name: 'MyForm',
            baseClass: 'JxForm',
            outputPath: 'src\\Widgets\\MyForm',
            osSlash: 'win',
            title: 'MyForm',
            description: '',
            top: 40,
            left: 40,
            width: 422,
            height: 275,
            strategies: DEFAULT_STRATEGIES,
            fields: [],
        });

    /**
     * Builds a normalized config object from raw form state.
     * Filters inactive fields, resolves outputPath, auto-adds schema strategy when fields exist.
     * @param {object} form - raw form state
     * @returns {object} normalized config
     */
    toConfig = (form) => {
        const slash = form.osSlash === 'win' ? '\\' : '/';
        const resolvedPath = form.outputPath.trim() || 'src' + slash + 'Widgets' + slash + form.name.trim();
        const activeFields = form.fields.filter((f) => f.active !== false && f.name.trim());
        const hasFields = activeFields.length > 0;
        return {
            rk: form.rk,
            name: form.name.trim(),
            baseClass: form.baseClass,
            outputPath: resolvedPath,
            osSlash: form.osSlash,
            title: form.title.trim() || form.name.trim(),
            description: form.description ?? '',
            top: Math.round(form.top) || 120,
            left: Math.round(form.left) || null,
            width: Math.round(form.width) || 600,
            height: Math.round(form.height) || 400,
            fields: activeFields,
            // strategies: hasFields && !form.strategies.includes('schema') ? [...form.strategies, 'schema'] : form.strategies,
            strategies: form.strategies,
        };
    };
}

const formBuilderFormState = new FormBuilderFormState();
export default formBuilderFormState;
